import { InertiaLink } from "@inertiajs/inertia-react";
import React from "react";

/**
 * DashboardMenu Component
 *
 * Provides the main navigation menu for the admin dashboard.
 * Displays navigation links to different dashboard sections with
 * active state highlighting for the current page.
 *
 * @param {Object} props - Component props
 * @param {string} props.active - The currently active menu item ("Orders", "Gebruikers", or "Kleuren")
 *
 * @returns {JSX.Element} The rendered dashboard navigation menu
 */
export default function DashboardMenu({ active }) {
    return (
        <>
            <InertiaLink
                className={`step ${active === "Orders" ? "active" : ""}`}
                name={"Orders"}
                href={"/dashboard/orders"}
            >
                Orders
            </InertiaLink>
            <InertiaLink
                className={`step ${active === "Gebruikers" ? "active" : ""}`}
                name={"Gebruikers"}
                href={"/dashboard/users"}
            >
                Gebruikers
            </InertiaLink>
            <InertiaLink
                className={`step ${active === "Kleuren" ? "active" : ""}`}
                name={"Kleuren"}
                href={"/dashboard/colors"}
            >
                Kleuren
            </InertiaLink>
        </>
    );
}
